/**
 * Публичные ассеты платформы.
 * Брендинг (логотип, favicon): только SEO-модуль (/api/seo/…) совместно с FILES — без platform-assets/branding.
 * Прочие иллюстрации: /api/platform-assets/...
 */

export const PLATFORM_ASSETS_BASE = '/api/platform-assets';

/** Hero для экрана входа app.markbase.ru (сжатый webp + jpg fallback). */
export const AUTH_HERO_VILLAGE_WEBP = '/images/auth/auth-hero-village.webp';
export const AUTH_HERO_VILLAGE_JPG = '/images/auth/auth-hero-village.jpg';

/**
 * WayGPT AI — каноническая иконка AI-помощника (не WaySen Companion).
 * SSOT: markbase.ru/platform-assets/waygpt/
 */
export const WAYGPT_AI_URL = `${PLATFORM_ASSETS_BASE}/waygpt/waygpt_ai.png`;
export const WAYGPT_AI_ICON_URL = `${PLATFORM_ASSETS_BASE}/waygpt/waygpt_ai_icon.png`;
export const WAYGPT_AI_CHIP_URL = `${PLATFORM_ASSETS_BASE}/waygpt/waygpt_ai_chip.png`;

/** Публичные иконки и логотип (единый вход SEO → редирект на URL из FILES). */
export const SEO_FAVICON_SVG = '/api/seo/favicon.svg';
export const SEO_FAVICON_ICO = '/api/seo/favicon.ico';

export const PLATFORM_BRANDING_SITE_LOGO = '/api/seo/site-logo.svg';
export const PLATFORM_BRANDING_FAVICON_SVG = SEO_FAVICON_SVG;

/** 3D-иконка модуля: white/ или dark/ по теме. Имена файлов: `{Name}_white.jpg`, `{Name}_dark.jpg`. */
export function platformModuleIconUrl(moduleKey, isDarkTheme) {
  const raw = typeof moduleKey === 'string' ? moduleKey.trim() : '';
  const key = raw && /^[A-Za-z][A-Za-z0-9_-]*$/.test(raw) ? raw : 'Markbase';
  const folder = isDarkTheme ? 'dark' : 'white';
  const suffix = isDarkTheme ? 'dark' : 'white';
  return `${PLATFORM_ASSETS_BASE}/moduls/icons/${folder}/${key}_${suffix}.jpg`;
}

const BRANDING_FILENAME_SEO = {
  'site-logo.svg': '/api/seo/site-logo.svg',
  'site_logo.svg': '/api/seo/site-logo.svg',
  'favicon.svg': SEO_FAVICON_SVG,
  'favicon.ico': SEO_FAVICON_ICO,
  'favicon.png': '/api/seo/favicon.png',
  'apple-touch-icon.png': '/api/seo/apple-touch-icon.png',
  'logo.png': '/api/seo/site-logo.svg',
};

export function platformBrandingUrl(filename) {
  const base = String(filename || '').split('/').pop() || 'site-logo.svg';
  return BRANDING_FILENAME_SEO[base] || '/api/seo/site-logo.svg';
}

export function platformErrorIllustrationUrl(code, isDarkTheme) {
  const variant = isDarkTheme ? 'dark' : 'white';
  return `${PLATFORM_ASSETS_BASE}/errors/${code}_${variant}.jpg`;
}

/**
 * Лендинг / PublicHeader: первичный URL из бэкенда при валидности, затем канон /api/seo.
 */
export function publicHeaderLogoSources(primarySiteLogoUrl) {
  const out = [];
  if (primarySiteLogoUrl && (/^https?:\/\//i.test(primarySiteLogoUrl) || primarySiteLogoUrl.startsWith('/'))) {
    out.push(primarySiteLogoUrl);
  }
  out.push(PLATFORM_BRANDING_SITE_LOGO, SEO_FAVICON_SVG);
  return out;
}

/** PublicFooter — только цепочка fallback (без первичного из state). */
export const PUBLIC_FOOTER_LOGO_SOURCES = [
  PLATFORM_BRANDING_SITE_LOGO,
  SEO_FAVICON_SVG,
];

/**
 * App shell (sidebar, auth): лого компании → site_logo из SEO/FILES (полное разрешение)
 * → канон /api/seo/site-logo.svg → favicon как последний fallback.
 */
export function appSidebarLogoSources(companyLogoUrl, siteLogoUrl) {
  const out = [];
  const pushIfSafe = (url) => {
    if (url && (url.startsWith('/') || /^https?:\/\//i.test(url))) {
      out.push(url);
    }
  };
  pushIfSafe(companyLogoUrl);
  pushIfSafe(siteLogoUrl);
  out.push(PLATFORM_BRANDING_SITE_LOGO, SEO_FAVICON_SVG);
  return out;
}
